<template>
  <div>
    <b-form-group label="Title (optional)">
      <b-input v-model="content.title" placeholder="e.g Awesome Tiles" />
    </b-form-group>

    <b-form-group label="Text above tiles (optional)">
      <b-input v-model="content.text_top" placeholder="e.g lorem ipsum" />
    </b-form-group>

    <b-form-group label="Text below tiles (optional)">
      <b-input v-model="content.text_bottom" placeholder="e.g lorem ipsum" />
    </b-form-group>

    <div class="mb-2 mt-3">Display mode</div>

    <b-form-checkbox-group
      v-model="content.mode"
      :options="modeOptions"
      name="mode"
      buttons
      class="mb-3"
    ></b-form-checkbox-group>

    <div class="d-flex">
      <b-form-group label="Equal height in px for desktop (optional)">
        <b-input v-model="content.height" type="number" placeholder="e.g 316" />
      </b-form-group>

      <b-form-group label="Equal height in px for mobile (optional)" class="ml-3">
        <b-input v-model="content.heightMobile" type="number" placeholder="e.g 316" />
      </b-form-group>

      <b-form-group v-if="content.mode === 'swipeable'" label="Number of slides for desktop (optional)" class="ml-3">
        <b-input v-model="content.slides" type="number" placeholder="e.g 4" />
      </b-form-group>

      <b-form-group v-if="content.mode === 'swipeable'" label="Number of slides for mobile (optional)" class="ml-3">
        <b-input v-model="content.slidesMobile" type="number" placeholder="e.g 1" />
      </b-form-group>
    </div>

    <div class="mb-2">Tiles</div>

    <template v-if="content.tiles">
      <b-row class="mb-3">
        <b-col>
          Image or Video link
        </b-col>
        <b-col>
          Alt text
        </b-col>
        <b-col>
          Link (optional)
        </b-col>
        <b-col>
          Title (optional)
        </b-col>
        <b-col>
          Text (optional)
        </b-col>
      </b-row>

      <b-row v-for="(tile, index) in content.tiles" :key="index" class="mb-3">
        <b-col>
          <b-input-group>
            <b-form-input
              placeholder="e.g https://youwish.no/images/logo.png"
              v-model="content.tiles[index].media"
              style="border-top-right-radius: 0; border-bottom-right-radius: 0;"
            />

            <b-form-input
              placeholder="e.g YouWish.no logo"
              v-model="content.tiles[index].alt"
              style="border-top-right-radius: 0; border-bottom-right-radius: 0;"
            />

            <b-form-input
              placeholder="e.g https://youwish.no"
              v-model="content.tiles[index].link"
              style="border-top-right-radius: 0; border-bottom-right-radius: 0;"
            />

            <b-form-input
              placeholder="e.g Wonderful tracks"
              v-model="content.tiles[index].title"
              style="border-top-right-radius: 0; border-bottom-right-radius: 0;"
            />

            <b-form-input
              placeholder="e.g lorem ipsum"
              v-model="content.tiles[index].text"
              style="border-top-right-radius: 0; border-bottom-right-radius: 0;"
            />

            <template #append>
              <b-button
                variant="danger"
                @click="() => removeTile(index)"
              >
                <strong>&times;</strong>
              </b-button>
            </template>
          </b-input-group>
        </b-col>
      </b-row>
    </template>

    <b-button variant="light" size="sm" @click="addEmptyTile">
      Add Tile
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'PagesTilesWidget',

  props: {
    value: {
      type: Object
    },
  },

  data() {
    return {
      content: this.value,
      resolved: {
        type: Object
      },
      modeOptions: [
        { text: 'Static', value: 'static' },
        { text: 'Swipeable', value: 'swipeable' },
        { text: 'Infinite scroll', value: 'infinite_scroll' },
      ],
    }
  },

  created() {
    if (!this.content.mode || this.content.mode.length === 0) {
      this.content.mode = 'static';
    }
  },


  methods: {
    addEmptyTile() {
      this.content.tiles.push({
        media: '',
        alt: '',
        link: '',
        title: '',
        text: '',
      })
    },

    removeTile(index) {
      if (this.content.tiles.length === 1) {
        this.content.tiles = []
        return
      }

      this.content.tiles.splice(index, 1)
    },
  },
}
</script>
